// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--19YEB","title":"styles-module--title--1SIzP","description":"styles-module--description--1F7H3"};